import { appSettingReducer } from "./states/app-setting/app-setting.reducer";
import { globalValueSlice } from "./states/global-value/global-value.slice";
import { accountSlice } from "states/account/account.slice";
import { localizationSlice } from "states/localization/localization.slice";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { branchSlice } from "states/branch/branch.slice";
import { wareHouseSlice } from "states/ware-house/ware-house.slice";
import { tagSlice } from "states/tag/tag.slice";
import { productAttributeSlice } from "states/product-attribute/product-attribute.slice";
import { unitSlice } from "states/unit/unit.slice";
import { transportationSlice } from "states/transportation/transportation.slice";
import { staffSlice } from "states/staff/staff.slice";
import { modifierGroupSlice } from "states/modifier-group/modifier-group.slice";
export const store = configureStore({
  reducer: combineReducers({
    appSetting: appSettingReducer,
    globalValue: globalValueSlice.reducer,
    account: accountSlice.reducer,
    localization: localizationSlice.reducer,
    branch: branchSlice.reducer,
    wareHouse: wareHouseSlice.reducer,
    tag: tagSlice.reducer,
    productAttribute: productAttributeSlice.reducer,
    unit: unitSlice.reducer,
    transportation: transportationSlice.reducer,
    staff: staffSlice.reducer,
    modifierGroup: modifierGroupSlice.reducer
  }),
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;
